import { COMMON_ERRORS } from 'modules/common/constants/errors.references';

export const ERROR_REFS = {
  ...COMMON_ERRORS,
  // add new error refs here
};

export const BLOCK_CAUSE_ERRORS = {
  [ERROR_REFS.DUPLICATE_KEY]: {
    title: 'blockCause:errors.duplicatedName',
    description: 'blockCause:errors.duplicatedNameDescription',
  }
};
